export default __webpack_public_path__ + "static/media/gallery_02.5ca9cb34.jpg";